import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, FileText } from "lucide-react";
import { toast } from "sonner";
import api, { apiError } from "../lib/api";
import Header from "../components/Header";
import UserNav from "../components/UserNav";

const fmtDate = (iso) => new Date(iso).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" });

export default function UserNotes() {
  const navigate = useNavigate();
  const [notes, setNotes] = useState(null);
  const [profileName, setProfileName] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const pid = localStorage.getItem("rb_profile");
        const { data: profiles } = await api.get("/profiles");
        const active = profiles.find((p) => p.id === pid) || profiles[0];
        if (!active) { setNotes([]); return; }
        setProfileName(active.name);
        const { data } = await api.get(`/profiles/${active.id}/notes`);
        setNotes(data);
      } catch (e) {
        toast.error(apiError(e));
        setNotes([]);
      }
    })();
  }, []);

  return (
    <div data-testid="user-notes-page" className="min-h-screen bg-background">
      <Header />
      <main className="max-w-2xl mx-auto px-4 py-8 pb-32">
        <button data-testid="back-button" onClick={() => navigate("/use")} className="min-h-[48px] px-4 rounded-full border-2 border-foreground/25 bg-white font-bold flex items-center gap-2 hover:bg-secondary transition-colors duration-200">
          <ArrowLeft size={20} strokeWidth={2.5} /> Back
        </button>

        <h1 className="mt-6 text-3xl font-extrabold tracking-tight flex items-center gap-3">
          <FileText size={32} strokeWidth={2.5} className="text-[#9F7AEA]" /> My notes
        </h1>
        <p className="mt-2 text-lg text-muted-foreground">Updates from your carers{profileName ? ` about ${profileName}` : ""}.</p>

        <div className="mt-6 space-y-4">
          {notes === null ? (
            <p className="text-lg text-muted-foreground">Loading…</p>
          ) : notes.length === 0 ? (
            <p data-testid="no-notes-message" className="bg-white rounded-3xl border-2 border-dashed border-foreground/20 p-8 text-lg text-muted-foreground">
              No notes yet.
            </p>
          ) : (
            notes.map((n) => (
              <div key={n.id} data-testid={`user-note-card-${n.id}`} className="bg-white rounded-3xl border-2 border-foreground/10 p-6">
                <p className="text-xl leading-relaxed whitespace-pre-wrap font-semibold">{n.text}</p>
                {n.photos?.length > 0 && (
                  <div className="mt-3 flex flex-wrap gap-3">
                    {n.photos.map((src, i) => (
                      <img key={i} src={src} alt="" className="w-32 h-32 rounded-2xl object-cover border-2 border-foreground/15" />
                    ))}
                  </div>
                )}
                <p className="mt-3 text-sm font-semibold text-muted-foreground">{n.author_name} · {fmtDate(n.created_at)}</p>
              </div>
            ))
          )}
        </div>
      </main>
      <UserNav />
    </div>
  );
}
